import axios, { AxiosError } from 'axios';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import generateCorrelationId from '../../../utils';
import type Document from '../../Document';

export async function fetchPDF(id: string, sourceType?: string) {
  const baseUrl = '/customer/document/archive';
  const endpoint =
    sourceType && sourceType.toUpperCase() === 'BANK'
      ? `${baseUrl}/bank/documents/${id}`
      : `${baseUrl}/documents/${id}`;

  const response = await axios.get<Blob>(endpoint, {
    responseType: 'blob',
    headers: {
      'X-Correlation-ID': `document-archive-web.${generateCorrelationId()}`,
    },
  });
  return response.data;
}

export function usePDF(
  id: Document.Id | undefined,
  sourceType?: Document.Source
): UseQueryResult<Blob | undefined, AxiosError | null> {
  return useQuery<Blob | undefined, AxiosError | null>({
    queryKey: ['documents', id, 'pdf', sourceType],
    queryFn: () => fetchPDF(id as string, sourceType),
    staleTime: Infinity,
    gcTime: Infinity,
    enabled: id !== undefined,
    retry: (failureCount, error) => {
      return failureCount < 2 && error?.status != 404;
    },
    meta: {
      datadogErrorMessage: `Failed to fetch PDF by id ${id}`,
    },
  });
}
